export const MAX_COMMAND_TIMEOUT = 120;
export const MAX_STACK_SIZE_LIMIT = 100000000;  // 100 MB
export const MAX_PROCESS_LIMIT = 150;

export const SYSADMIN_CONTACT = 'your instructor or system administrator';
